export default __webpack_public_path__ + "static/media/designdev.0f58191c.PNG";